import { configureStore } from '@reduxjs/toolkit';
import dataReducer from '../store/Features/Currentpages';

export default configureStore({
  reducer: {
    Data: dataReducer,
  },
});
